import { render, staticRenderFns } from "./CompetitionSwitcher.vue?vue&type=template&id=926a3cd6&scoped=true"
import script from "./CompetitionSwitcher.vue?vue&type=script&lang=js"
export * from "./CompetitionSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CompetitionSwitcher.vue?vue&type=style&index=0&id=926a3cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926a3cd6",
  null
  
)

export default component.exports